module.exports = __webpack_public_path__ + "img/victory-points.9382a1bb.svg";